export default __webpack_public_path__ + "static/char-62-anr-66d8874aab4e07651abf278353a4e2c8.gif";